// extracted by mini-css-extract-plugin
export default {"mk_l":"markdown_mk_l__oaQ-f","mk_d":"markdown_mk_d__owYkB"};